const FromArr = [{
		modelvalue: '',
		title: "授权经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "订货经销商名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "授权书编号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 15,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "产品线：",
		inputtype: "select",
		multiple: true,
		collapseTags: true,
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 70,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		modelvalue: '',
		title: "审批流状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	},
	{
		hidden: true,
		modelvalue: '',
		title: "待我审批：",
		inputtype: "checkebox",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 190,
		height: 32,
		disabled: false,
		marginLeft: 30,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
				key: '0',
				value: '否'
			},
			{
				key: '1',
				value: '是'
			}
		]
	},
	{
		title: "创建时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "发布时间",
		widthLeft: 190,
		widthRight: 300,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 55,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "医院名称：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 26,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		modelvalue: '',
		title: "申请单号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 505,
		height: 32,
		disabled: false,
		marginLeft: 53,
		marginTop: 10,
		displayVal: "inline-block",
		fontWeightVal: 500
	},

];
export default FromArr;